import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Model, { attr, hasMany, belongsTo } from '@ember-data/model';
import { inject } from '@ember/service';
import getConfig from 'beebee-base/lib/get-config';

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec0, _dec1, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _dec29, _dec30, _dec31, _dec32, _dec33, _dec34, _dec35, _dec36, _dec37, _dec38, _dec39, _dec40, _dec41, _dec42, _dec43, _dec44, _dec45, _dec46, _dec47, _dec48, _dec49, _dec50, _dec51, _dec52, _dec53, _dec54, _dec55, _dec56, _dec57, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35, _descriptor36, _descriptor37, _descriptor38, _descriptor39, _descriptor40, _descriptor41, _descriptor42, _descriptor43, _descriptor44, _descriptor45, _descriptor46, _descriptor47, _descriptor48, _descriptor49, _descriptor50, _descriptor51, _descriptor52, _descriptor53, _descriptor54, _descriptor55, _descriptor56, _descriptor57, _descriptor58;
let OrganizationModel = (_dec = attr('string'), _dec2 = attr('string'), _dec3 = attr('string'), _dec4 = attr('string'), _dec5 = attr('string'), _dec6 = attr('string'), _dec7 = attr('string'), _dec8 = attr('string'), _dec9 = attr('string'), _dec0 = attr('string'), _dec1 = attr('string'), _dec10 = attr('string'), _dec11 = attr('string'), _dec12 = attr('string'), _dec13 = attr('string'), _dec14 = attr('string'), _dec15 = attr('string'), _dec16 = attr('string'), _dec17 = attr('string'), _dec18 = attr('string'), _dec19 = attr('string'), _dec20 = attr('string'), _dec21 = attr('string'), _dec22 = attr('string'), _dec23 = attr('string'), _dec24 = attr('string'), _dec25 = attr('string'), _dec26 = attr('string'), _dec27 = attr('string'), _dec28 = attr('string'), _dec29 = hasMany('payment_method', {
  inverse: null,
  async: false
}), _dec30 = belongsTo('custom_reminder', {
  inverse: null,
  async: false
}), _dec31 = hasMany('event_state', {
  inverse: 'organization',
  async: false
}), _dec32 = hasMany('contact_state', {
  inverse: 'organization',
  async: false
}), _dec33 = hasMany('product_state', {
  inverse: 'organization',
  async: false
}), _dec34 = hasMany('project_state', {
  inverse: 'organization',
  async: false
}), _dec35 = hasMany('workhour_state', {
  inverse: 'organization',
  async: false
}), _dec36 = hasMany('organization_custom_field', {
  inverse: 'organization',
  async: false
}), _dec37 = attr('number'), _dec38 = hasMany('category', {
  inverse: 'organization',
  async: false
}), _dec39 = hasMany('product_category', {
  inverse: null,
  async: false
}), _dec40 = attr('string'), _dec41 = attr('string'), _dec42 = attr('string'), _dec43 = attr('string'), _dec44 = hasMany('file', {
  inverse: null,
  async: true
}), _dec45 = attr('string'), _dec46 = attr('string'), _dec47 = attr('string'), _dec48 = attr('string'), _dec49 = hasMany('role', {
  inverse: null,
  async: false
}), _dec50 = attr('boolean'), _dec51 = attr('boolean'), _dec52 = attr('string'), _dec53 = attr('string'), _dec54 = attr('string'), _dec55 = belongsTo('subscription', {
  inverse: 'organization',
  async: false
}), _dec56 = attr('string'), _dec57 = attr('boolean', {
  defaultValue: false
}), _class = class OrganizationModel extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "session", _descriptor, this);
    _initializerDefineProperty(this, "created_at", _descriptor2, this);
    _initializerDefineProperty(this, "organization", _descriptor3, this);
    _initializerDefineProperty(this, "name", _descriptor4, this);
    _initializerDefineProperty(this, "dashboard_name", _descriptor5, this);
    _initializerDefineProperty(this, "contact_name", _descriptor6, this);
    _initializerDefineProperty(this, "contacts_name", _descriptor7, this);
    _initializerDefineProperty(this, "product_name", _descriptor8, this);
    _initializerDefineProperty(this, "products_name", _descriptor9, this);
    _initializerDefineProperty(this, "project_name", _descriptor0, this);
    _initializerDefineProperty(this, "projects_name", _descriptor1, this);
    _initializerDefineProperty(this, "event_name", _descriptor10, this);
    _initializerDefineProperty(this, "events_name", _descriptor11, this);
    _initializerDefineProperty(this, "tracker_name", _descriptor12, this);
    _initializerDefineProperty(this, "trackers_name", _descriptor13, this);
    _initializerDefineProperty(this, "estimate_name", _descriptor14, this);
    _initializerDefineProperty(this, "estimates_name", _descriptor15, this);
    _initializerDefineProperty(this, "invoice_name", _descriptor16, this);
    _initializerDefineProperty(this, "invoices_name", _descriptor17, this);
    _initializerDefineProperty(this, "receipt_name", _descriptor18, this);
    _initializerDefineProperty(this, "receipts_name", _descriptor19, this);
    _initializerDefineProperty(this, "expense_name", _descriptor20, this);
    _initializerDefineProperty(this, "expenses_name", _descriptor21, this);
    _initializerDefineProperty(this, "cost_name", _descriptor22, this);
    _initializerDefineProperty(this, "costs_name", _descriptor23, this);
    _initializerDefineProperty(this, "order_name", _descriptor24, this);
    _initializerDefineProperty(this, "orders_name", _descriptor25, this);
    _initializerDefineProperty(this, "contract_name", _descriptor26, this);
    _initializerDefineProperty(this, "contracts_name", _descriptor27, this);
    _initializerDefineProperty(this, "ddt_name", _descriptor28, this);
    _initializerDefineProperty(this, "ddts_name", _descriptor29, this);
    _initializerDefineProperty(this, "payment_methods", _descriptor30, this);
    _initializerDefineProperty(this, "custom_reminder", _descriptor31, this);
    _initializerDefineProperty(this, "event_states", _descriptor32, this);
    _initializerDefineProperty(this, "contact_states", _descriptor33, this);
    _initializerDefineProperty(this, "product_states", _descriptor34, this);
    _initializerDefineProperty(this, "project_states", _descriptor35, this);
    _initializerDefineProperty(this, "workhour_states", _descriptor36, this);
    _initializerDefineProperty(this, "organization_custom_fields", _descriptor37, this);
    _initializerDefineProperty(this, "sms_remained", _descriptor38, this);
    _initializerDefineProperty(this, "categories", _descriptor39, this);
    _initializerDefineProperty(this, "product_categories", _descriptor40, this);
    _initializerDefineProperty(this, "thumbnail_url", _descriptor41, this);
    _initializerDefineProperty(this, "thumbnail_name", _descriptor42, this);
    _initializerDefineProperty(this, "thumbnail_etag", _descriptor43, this);
    _initializerDefineProperty(this, "thumbnail_type", _descriptor44, this);
    _initializerDefineProperty(this, "files", _descriptor45, this);
    _initializerDefineProperty(this, "primary_color", _descriptor46, this);
    _initializerDefineProperty(this, "primary_text_color", _descriptor47, this);
    _initializerDefineProperty(this, "secondary_color", _descriptor48, this);
    _initializerDefineProperty(this, "secondary_text_color", _descriptor49, this);
    _initializerDefineProperty(this, "roles", _descriptor50, this);
    _initializerDefineProperty(this, "new_registration", _descriptor51, this);
    _initializerDefineProperty(this, "beta_test", _descriptor52, this);
    _initializerDefineProperty(this, "alta_stagione_start", _descriptor53, this);
    _initializerDefineProperty(this, "alta_stagione_end", _descriptor54, this);
    _initializerDefineProperty(this, "option_field", _descriptor55, this);
    _initializerDefineProperty(this, "subscription", _descriptor56, this);
    _initializerDefineProperty(this, "accepted_terms_date", _descriptor57, this);
    _initializerDefineProperty(this, "my_dirty", _descriptor58, this);
  }
  get workhour_name() {
    return this.tracker_name;
  }
  get workhours_name() {
    return this.trackers_name;
  }
  get payment_name() {
    return this.cost_name;
  }
  get payments_name() {
    return this.costs_name;
  }
  get thumbnail_api_url() {
    if (!this.session.token || !this.thumbnail_url) {
      return null;
    }
    return `${getConfig(this).APP.urlApi}/app/file?access_token=${this.session.token}&name=${encodeURIComponent(this.thumbnail_name ?? '')}&url=${encodeURIComponent(this.thumbnail_url)}`;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "session", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "created_at", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "organization", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "name", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "dashboard_name", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "contact_name", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "contacts_name", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "product_name", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "products_name", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "project_name", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "projects_name", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "event_name", [_dec1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "events_name", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "tracker_name", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "trackers_name", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "estimate_name", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "estimates_name", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "invoice_name", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "invoices_name", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "receipt_name", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "receipts_name", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "expense_name", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "expenses_name", [_dec20], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "cost_name", [_dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "costs_name", [_dec22], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "order_name", [_dec23], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "orders_name", [_dec24], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "contract_name", [_dec25], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "contracts_name", [_dec26], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "ddt_name", [_dec27], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "ddts_name", [_dec28], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "payment_methods", [_dec29], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "custom_reminder", [_dec30], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "event_states", [_dec31], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor33 = _applyDecoratedDescriptor(_class.prototype, "contact_states", [_dec32], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor34 = _applyDecoratedDescriptor(_class.prototype, "product_states", [_dec33], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor35 = _applyDecoratedDescriptor(_class.prototype, "project_states", [_dec34], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor36 = _applyDecoratedDescriptor(_class.prototype, "workhour_states", [_dec35], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor37 = _applyDecoratedDescriptor(_class.prototype, "organization_custom_fields", [_dec36], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor38 = _applyDecoratedDescriptor(_class.prototype, "sms_remained", [_dec37], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor39 = _applyDecoratedDescriptor(_class.prototype, "categories", [_dec38], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor40 = _applyDecoratedDescriptor(_class.prototype, "product_categories", [_dec39], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor41 = _applyDecoratedDescriptor(_class.prototype, "thumbnail_url", [_dec40], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor42 = _applyDecoratedDescriptor(_class.prototype, "thumbnail_name", [_dec41], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor43 = _applyDecoratedDescriptor(_class.prototype, "thumbnail_etag", [_dec42], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor44 = _applyDecoratedDescriptor(_class.prototype, "thumbnail_type", [_dec43], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor45 = _applyDecoratedDescriptor(_class.prototype, "files", [_dec44], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor46 = _applyDecoratedDescriptor(_class.prototype, "primary_color", [_dec45], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor47 = _applyDecoratedDescriptor(_class.prototype, "primary_text_color", [_dec46], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor48 = _applyDecoratedDescriptor(_class.prototype, "secondary_color", [_dec47], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor49 = _applyDecoratedDescriptor(_class.prototype, "secondary_text_color", [_dec48], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor50 = _applyDecoratedDescriptor(_class.prototype, "roles", [_dec49], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor51 = _applyDecoratedDescriptor(_class.prototype, "new_registration", [_dec50], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor52 = _applyDecoratedDescriptor(_class.prototype, "beta_test", [_dec51], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor53 = _applyDecoratedDescriptor(_class.prototype, "alta_stagione_start", [_dec52], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor54 = _applyDecoratedDescriptor(_class.prototype, "alta_stagione_end", [_dec53], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor55 = _applyDecoratedDescriptor(_class.prototype, "option_field", [_dec54], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor56 = _applyDecoratedDescriptor(_class.prototype, "subscription", [_dec55], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor57 = _applyDecoratedDescriptor(_class.prototype, "accepted_terms_date", [_dec56], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor58 = _applyDecoratedDescriptor(_class.prototype, "my_dirty", [_dec57], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { OrganizationModel as default };
//# sourceMappingURL=organization.js.map
